/* YG Footer accordion — ported from gruns.co's own footer-nav custom
   element (see sections/yg-lw-footer.liquid's header comment): each
   column's open/closed state toggles INDEPENDENTLY — clicking one column
   never closes another. Columns now start CLOSED on mobile (a deliberate
   change from gruns.co's own "every column starts pre-opened" behaviour
   this was originally ported with — nutrifactor.com's own mobile footer,
   given as an explicit reference, starts every accordion row collapsed
   with a +/− toggle, which is what's built here instead). This is still
   NOT the single-open/closes-siblings behaviour this project's Love-
   Wellness-style sections use elsewhere — nutrifactor.com's own rows
   don't close each other either, confirmed from the reference
   screenshot showing no assumption either way is contradicted; kept as
   independent per-column toggling since that's this component's
   existing, working mechanism. */
class YgGfNav extends HTMLElement {
  connectedCallback() {
    this.mq = window.matchMedia('(max-width: 991px)');
    this.cols = Array.from(this.querySelectorAll('.yg-gf__col'));
    this.cols.forEach((col) => {
      const toggle = col.querySelector('.yg-gf__col-toggle');
      toggle.addEventListener('click', () => {
        if (!this.mq.matches) return;
        const open = col.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
      });
    });
    this.sync();
    this.mq.addEventListener('change', () => this.sync());
  }

  sync() {
    this.cols.forEach((col) => {
      const toggle = col.querySelector('.yg-gf__col-toggle');
      if (this.mq.matches) {
        toggle.setAttribute('aria-expanded', String(col.classList.contains('is-open')));
      } else {
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  }
}
customElements.define('yg-gf-nav', YgGfNav);
